import { themePreferenceResource } from '@jira/router-resources__theme-preference/src/useThemePreference.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const jiraSpaResources = (): RouteResource[] => [themePreferenceResource];
